module.exports = __webpack_public_path__ + "img/bigtx_bj.640498f9.png";